import React from 'react';

const Bulkstep2 = () => {
    return (
        <>
        <div style={{'display':'flex  '}}>
           <div style={{'border':'1px solid #9f9f9f', 'width':'30%'}}>
            <h3>identifier: 1</h3>
            <input />
            <img/>
            </div>
            <div style={{'border':'1px solid #9f9f9f', 'width':'30%'}}>
            <h3>identifier: 1</h3>
            <input />
            <img/>
            </div>
            <div style={{'border':'1px solid #9f9f9f', 'width':'30%'}}>
            <h3>identifier: 1</h3>
            <input />
            <img/>
            </div>
        </div>
        </>

    );
};

export default Bulkstep2;